import { useEffect } from "react";
import { Plus, Trash2 } from "lucide-react";
import { useFieldArray } from "react-hook-form";
const ArrayInputField = ({
  control,
  register,
  errors,
  name,
  label,
  type,
  placeholder,
  setValue,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: name,
  });

  useEffect(() => {
    fields.forEach((field, index) => {
      setValue(`${name}[${index}].number`, index + 1);
    });
  }, [fields, setValue, name]);

  return (
    <div className="mb-10 ">
      <div className="flex items-center justify-between text-base p-3 relative">
        <label className="block mb-0.5 text-text-1/90 font-medium">
          {label}
        </label>
        {errors && errors.message && (
          <p className="input-error text-xs text-red-500 absolute top-5 left-40  ">
            {errors.message}
          </p>
        )}
        <button
          type="button"
          className="header-btn"
          onClick={() => append({ id: null, number: 0, name: "" })}
        >
          <Plus size={20} />
        </button>
      </div>
      {fields.map((field, index) => (
        <div key={field.id} className="input-container relative mb-2">
          <div className="flex justify-center items-center gap-4">
            <p className="text-text-1/75">{index + 1}</p>
            <input
              type={type}
              placeholder={placeholder}
              className="w-full bg-content px-3 py-0.5 border-b-2 text-base rounded-none border-b-bkg2 focus:outline-none focus:border-b-primary text-text-1/75"
              defaultValue={field.value}
              {...register(`${name}.${index}.name`)}
            />
            {errors && errors[index]?.name && (
              <p className="input-error-text ">{errors[index].name.message}</p>
            )}
            <button
              type="button"
              className=" text-red-500 px-3"
              onClick={() => remove(index)}
            >
              <Trash2 size={20} />
            </button>
          </div>
          <input
            type="hidden"
            placeholder={placeholder}
            className="w-full px-3 py-0.5 border-b-2 text-base rounded-none border-b-bkg2 focus:outline-none focus:border-b-primary text-text-1"
            {...register(`${name}.${index}.number`)}
            defaultValue={index + 1}
          />
          <input
            type="hidden"
            placeholder={placeholder}
            className="w-full px-3 py-0.5 border-b-2 text-base rounded-none border-b-bkg2 focus:outline-none focus:border-b-primary text-text-1"
            {...register(`${name}.${index}.id`)}
            // defaultValue={index + 1}
          />
        </div>
      ))}
    </div>
  );
};
export default ArrayInputField;
